'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createOfferPayload = undefined;

var _ChargeTypes = require('self-service-api/constants/ChargeTypes');

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reduceItemConfigByChargeType = function reduceItemConfigByChargeType(itemConfigs, chargeType) {
  return itemConfigs.filter(function (itemConfig) {
    var properties = _ImmutableMerchandiseIdMap2.default[itemConfig.merchandiseId];
    return properties.chargeType === chargeType;
  }).map(function (_ref) {
    var merchandiseId = _ref.merchandiseId,
        quantity = _ref.quantity;

    if (_ImmutableMerchandiseIdMap2.default[merchandiseId].quantityMultiplier !== null) {
      var quantityMultiplier = _ImmutableMerchandiseIdMap2.default[merchandiseId].quantityMultiplier;
      var calculatedQuantity = Math.ceil(quantity / quantityMultiplier);

      return { id: merchandiseId, quantity: calculatedQuantity };
    }

    return { id: merchandiseId, quantity: quantity };
  });
};

var createOfferPayload = exports.createOfferPayload = function createOfferPayload(_ref2) {
  var termId = _ref2.termId,
      _ref2$itemConfigurati = _ref2.itemConfigurations,
      itemConfigurations = _ref2$itemConfigurati === undefined ? [] : _ref2$itemConfigurati,
      _ref2$productBasedOff = _ref2.productBasedOffers,
      productBasedOffers = _ref2$productBasedOff === undefined ? [] : _ref2$productBasedOff;

  var offerItemConfigurations = [];

  var recurringItems = reduceItemConfigByChargeType(itemConfigurations, _ChargeTypes.RECURRING);

  if (recurringItems.length) {
    offerItemConfigurations.push({
      offerId: termId,
      itemConfigurations: recurringItems
    });
  }

  var nonRecurringItemConfigurations = reduceItemConfigByChargeType(itemConfigurations, _ChargeTypes.NON_RECURRING);

  productBasedOffers.forEach(function (productBasedOfferId) {
    offerItemConfigurations.push({
      offerId: productBasedOfferId,
      itemConfigurations: []
    });
  });

  return { offerItemConfigurations: offerItemConfigurations, nonRecurringItemConfigurations: nonRecurringItemConfigurations };
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/core/utilities/createOfferPayload.js
// module id = 587
// module chunks = 3 4 5